import React from "react";
import {
    Container,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Card,
    CardContent,
    ThemeProvider,
    createTheme,
    CssBaseline,
    List,
    ListItem,
    ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Pageheader } from "./global-components/page-header";
import bgImage from '../assets/img/newimgaes/T and cs policy.jpeg';


const theme = createTheme({
    palette: {
        primary: {
            main: "#10374A",
        },
        text: {
            primary: "#10374A",
            secondary: "#ffffff",
        },
    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
        h4: {
            fontWeight: 700,
            fontSize: "2rem",
            color: "#10374A",
        },
        body1: {
            fontSize: "1rem",
            lineHeight: 1.6,
        },
    },
});

const PrivacyPolicy = () => {
    const privacyRights = [
        {
            label: "a)",
            text: "The right to be informed about our collection and use of your personal data. This Privacy Policy should tell you everything you need to know, but you can always contact us using the details in Part 10.",
        },
        {
            label: "b)",
            text: "The right to access the personal data we hold about you. Part 9 will tell you how to do this.",
        },
        {
            label: "c)",
            text: "The right to have your personal data corrected if any of the personal data held by us is inaccurate or incomplete.",
        },
        {
            label: "d)",
            text: "The right to request deletion of your personal data where applicable under law.",
        },
        {
            label: "e)",
            text: "The right to restrict or object to certain processing of your personal data.",
        },
        {
            label: "f)",
            text: "The right to withdraw consent at any time, where we rely on your consent for processing.",
        },
        {
            label: "g)",
            text: "The right to data portability where applicable under law.",
        },
        {
            label: "h)",
            text: "Rights relating to automated decision-making and profiling. We do not use your personal data in this way.",
        },
    ];
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Pageheader headertitle={"Privacy Policy"} bgImage={bgImage} />
            <Container maxWidth="md" sx={{ padding: "2rem 1rem" }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Privacy Policy
                </Typography>
                <Card sx={{ backgroundColor: "#F9FAFB", marginBottom: "1.5rem" }}>
                    <CardContent>
                        <Typography variant="body1" color="text.primary">
                            Royale Spaces Limited understands that your privacy is important to you and that you care about how your personal data is used. We respect and value the privacy of everyone who visits this website, royalespaces.in (“our site”) and only collect and use your personal data as described in this Privacy Policy. Any personal data we collect will only be used as permitted by law. Please read this Privacy Policy carefully and ensure that you understand it. Your acceptance of this Privacy Policy is requested when forms on the website are completed and submitted by you.
                        </Typography>
                    </CardContent>
                </Card>
                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A", color: '#fff' }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Information About Us</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Our Site is owned and operated by Royale Spaces (India) Limited, a leading Real Estate Agency registered in India.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>Registered address:</strong> India
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            <strong>Main trading address:</strong> India
                        </Typography>

                        <Typography variant="body1" color="text.primary" sx={{ mt: 2, fontWeight: 'bold' }}>
                            Data Protection Officer:
                        </Typography>
                        <div style={{ paddingLeft: '20px' }}>
                            <Typography variant="body1" color="text.primary"><strong>Email address:</strong> info@royalespaces.com</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Telephone number:</strong> +91-7893092211</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Postal address:</strong> Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh</Typography>
                        </div>

                        <Typography variant="body1" color="text.primary" sx={{ mt: 2, fontWeight: 'bold' }}>
                            Representative:
                        </Typography>
                        <div style={{ paddingLeft: '20px' }}>
                            <Typography variant="body1" color="text.primary"><strong>Email address:</strong> info@royalespaces.com</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Telephone number:</strong> +91-7893092211</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Postal address:</strong> Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh</Typography>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">What Does This Policy Cover?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            This Privacy Policy applies only to your use of our site. Our site may contain links to other websites. Please note that we have no control over how your data is collected, stored, or used by other websites and we advise you to check the privacy policies of any such websites before providing any data to them.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">What is Personal Data?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Personal data is defined under the Information Technology Act, 2000 and applicable data protection laws in India as any information relating to an identifiable individual.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            Personal data, in simpler terms, is any information about you that enables you to be identified. This includes obvious information such as your name and contact details, as well as less obvious information such as identification numbers, electronic location data, and other online identifiers.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">What are My Rights?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Under applicable Indian data protection laws, you have the following rights, which we will always work to uphold:
                        </Typography>
                        <List>
                            {privacyRights.map((item, index) => (
                                <ListItem key={index} alignItems="flex-start">
                                    <Typography
                                        variant="body1"
                                        component="span"
                                        sx={{ fontWeight: "bold", marginRight: "8px" }}
                                    >
                                        {item.label}
                                    </Typography>
                                    <ListItemText primary={item.text} />
                                </ListItem>
                            ))}
                        </List>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 2 }}>
                            For more information about your rights or to exercise them, please contact us using the details in Part 10.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            It is important that your personal data is kept accurate and up to date. If any of the personal data we hold about you changes, please keep us informed.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            If you have any cause for complaint about our use of your personal data, you may contact us directly using the details in Part 10. We will make every effort to resolve your concerns promptly.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">What Personal Data Do You Collect and How?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Our site collects certain information automatically, including your IP address, the type of browser you are using, and certain other non-personal data about your device such as your operating system type or version and display resolution.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            If you send us an email or submit a form, we may collect your name, your email address, your phone number, and any other information you choose to provide.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            To respond to your requirements, when you register with this website, we will need to know your name, email address, and contact telephone number.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            Your information may be shared with our approved agencies (All Vendors and Brokers) or partners for customer research, service delivery, and analysis purposes. The results of such research and analysis are used purely to improve the quality of our services.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            The lawful basis for processing your personal data includes your consent and/or our legitimate business interests, as permitted under applicable Indian laws.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How Do You Use My Personal Data?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            Where we collect any personal data, it will be processed and stored securely and only for as long as is necessary for the purpose(s) for which it was collected.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            If you contact us, we may use your personal data to respond to your enquiry. Technical data is used for the operation and security of our site and will not normally be used to personally identify you.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            You may be contacted by email, telephone, or post by our representatives to provide service-related information, updates, feedback requests, or information about our services.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How and Where Do You Store My Data?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            We store your personal data primarily in India and/or in secure servers located in countries that provide an adequate level of data protection as per Indian law.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            Personal data security is essential to us. We take the following measures:
                        </Typography>
                        <List sx={{ listStyleType: "disc", pl: 4 }}>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="Limiting access to personal data to employees, agents, contractors, and third parties with a legitimate need to know." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="Ensuring such parties are subject to confidentiality obligations." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="Implementing procedures for handling data breaches, including notifying affected users and relevant authorities where legally required." />
                            </ListItem>
                        </List>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Do You Share My Personal Data?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            We do not sell your personal data. However, we may share your data in the following circumstances:
                        </Typography>
                        <List sx={{ listStyleType: "disc", pl: 4 }}>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="If we sell, transfer, or merge parts of our business or assets, your personal data may be transferred to the new owner." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="If required to do so by law, court order, or government authority." />
                            </ListItem>
                            <ListItem sx={{ display: "list-item" }}>
                                <ListItemText primary="With service providers for hosting, data storage, or operational purposes, such as: One.com, Hostinger." />
                            </ListItem>
                        </List>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            If any of your personal data is transferred outside India, we will take appropriate steps to ensure that your data is protected in accordance with applicable laws and security standards.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How Can I Access My Personal Data?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            You have the right to request access to the personal data we hold about you. This is known as a “subject access request.”
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            All such requests should be made in writing and sent to the email or postal addresses listed in Part 10.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">How Do I Contact You?</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            To contact us about anything related to your personal data or this Privacy Policy, please use the following details:
                        </Typography>
                        <div style={{ marginTop: '10px' }}>
                            <Typography variant="body1" color="text.primary"><strong>Email address:</strong> info@royalespaces.com</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Telephone number:</strong> +91-7893092211</Typography>
                            <Typography variant="body1" color="text.primary"><strong>Postal address:</strong> Door No. 7-331/20, Tulasi Plaza, M.M. Donka (O), Ongole, Prakasam – 523002, Andhra Pradesh</Typography>
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: "1rem", border: "1px solid #10374A" }} defaultExpanded>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                        sx={{ backgroundColor: "#10374A", color: "#ffffff !important" }}
                    >
                        <Typography color="#fff">Changes to this Privacy Policy</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#F9FAFB" }}>
                        <Typography variant="body1" color="text.primary">
                            We may change this Privacy Policy from time to time. This may be necessary due to changes in law or business operations.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1 }}>
                            Any changes will be posted on our site and will take effect immediately. We recommend checking this page regularly.
                        </Typography>
                        <Typography variant="body1" color="text.primary" sx={{ mt: 1, fontWeight: 'bold' }}>
                            This Privacy Policy was last updated on 28/01/2026.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </ThemeProvider>
    );
};

export default PrivacyPolicy;
